const localConfig = {
  ApiServiceUrl: 'https://aubusa.dev.autobestdevops.com',
  // 静态资源路径
  AssetServiceUrl: 'https://aubusa.dev.autobestdevops.com'
};

const devConfig = {
  ApiServiceUrl: '',
  AssetServiceUrl: ''
};

const testConfig = {
  ApiServiceUrl: '',
  AssetServiceUrl: ''
};

const uatConfig = {
  ApiServiceUrl: '',
  AssetServiceUrl: ''
};

const prodConfig = {
  ApiServiceUrl: '',
  AssetServiceUrl: ''
};

function getCurrentEnvConfig(currentEnv) {
  let config = {};
  const env = currentEnv || process.env.REACT_APP_ENV || 'dev';
  switch (env.trim()) {
    case 'local':
      config = localConfig;
      break;
    case 'dev':
      config = devConfig;
      break;
    case 'test':
      config = testConfig;
      break;
    case 'prod':
      config = prodConfig;
      break;
    case 'uat':
      config = uatConfig;
      break;
    default:
  }
  if (currentEnv) {
    config.REACT_APP_ENV = currentEnv;
  }
  config.REACT_APP_VERSION = process.env.REACT_APP_VERSION;
  return config;
}

module.exports = {
  getCurrentEnvConfig
};
